import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import createStyles from '@material-ui/core/styles/createStyles';
import HelpButton from '../buttons/HelpButton';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      position: 'relative',
      color: theme.palette.text.primary,
      [theme.breakpoints.down('xs')]: {
        minHeight: 100,
        backgroundImage: `linear-gradient(to right, ${theme.extraColors.headlineBackgroundLeft}, ${theme.extraColors.headlineBackgroundRight})`,
        borderRadius: 8,
        padding: '13px 32px 13px 13px',
        color: theme.palette.primary.contrastText,
      },
    },
    title: {
      display: 'inline-block',
      margin: '0 0 43px 0',
      fontWeight: 700,
      fontSize: 18,
      letterSpacing: '-0.3px',
      [theme.breakpoints.down('xs')]: {
        fontSize: 14,
        marginBottom: 25,
      },
    },
    description: {
      fontSize: 16,
      margin: '0 0 21px 0',
      [theme.breakpoints.down('xs')]: {
        fontSize: 12,
        marginBottom: 0,
      },
    },
  }),
);

interface Props {
  onHelpClick?: (props: any) => void;
  title: string | React.ReactElement;
  description?: string | null;
  helpIcon?: boolean;
}

const HeadLineBox: React.FC<Props> = ({ onHelpClick, title, description, helpIcon = true }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <p className={classes.title}>
        {title}
        {helpIcon && <HelpButton onHelpClick={(open: boolean) => onHelpClick && onHelpClick(open)} />}
      </p>
      {description && <p className={classes.description}>{description}</p>}
    </div>
  );
};

export default HeadLineBox;
